import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getSkladonMappingListFetchSuccess, getSkladonMappingListFetchFailure } from './reducer';
import { SkladonMappingsListResType } from 'src/types/skladonMappingList';

export const getSkladonMappingListFetchRequest = async (providerId?: number) => {
    const res = await api('get', providerId ? `api/secure/skladon-mapping/providers/${providerId}` : 'api/secure/skladon-mapping');
    return res.data.data;
};

function* getSkladonMappingListFetch(action: { type: string; payload?: number }) {
    try {
        const response: SkladonMappingsListResType = yield call((): any => getSkladonMappingListFetchRequest(action.payload));
        yield put(getSkladonMappingListFetchSuccess(response));
    } catch (error) {
        yield put(getSkladonMappingListFetchFailure({ error }));
    }
}

export function* getSkladonMappingListFetchWatch() {
    yield takeEvery('skladonMappingList/getSkladonMappingListFetch', getSkladonMappingListFetch);
}
